import { render, staticRenderFns } from "./appFeature.vue?vue&type=template&id=397db368"
import script from "./appFeature.vue?vue&type=script&lang=js"
export * from "./appFeature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports